import styles from "./Status.module.scss";

export interface StatusProps {
  variant: "positive" | "warning" | "negative" | "neutral" | "info" | "awaiting-justification",
}

const Status: React.FC<React.PropsWithChildren<StatusProps>> = ({
  variant,
  children,
}) => {
  return (
    <div className={`${styles.status} ${styles[variant]}`}>
      {children}
    </div>
  );
};

export default Status;
